import { tsRestClient } from "@api/tsRest";

import { CreateUserFileRequestType, GetChatRequestType, RateChatRequestType } from "@interfaces/chat.type";

import { IMessage } from "@pages/Technology/components/TechnologyMarketingSummary";

export const openaiChat = async (data: GetChatRequestType) => {
  const { body, status } = await tsRestClient.chat.chatRequest({
    body: {
      messages: data.messages,
      model: data.model,
      stream: true,
    },
  });

  if (status === 429) throw new Error("Chat usage limit exceeded");

  if (status !== 200) throw new Error("Failed to get chat response");

  return body;
};

export const persistChatMessages = async (technologyId: string, messages: IMessage[]) => {
  const { body, status } = await tsRestClient.chat.persistChatMessages({
    body: {
      messages,
      technologyId,
    },
  });

  if (status !== 200) throw new Error("Failed to persist chat messages");

  return body;
};

export const loadChatMessages = async (technologyId: string) => {
  const { body, status } = await tsRestClient.chat.loadChatMessages({
    params: {
      technologyId,
    },
  });

  if (status !== 200) throw new Error("Failed to load chat messages");

  return body;
};

export const deleteChatHistory = async (technologyId: string) => {
  const { body, status } = await tsRestClient.chat.deleteChatMessages({
    body: {
      technologyId,
    },
  });

  if (status !== 200) throw new Error("Failed to delete chat history");

  return body;
};

export const rateChatMessage = async (data: RateChatRequestType) => {
  const { body, status } = await tsRestClient.chat.rateChatMessage({
    body: data,
  });

  if (status !== 200) throw new Error("Failed to rate chat message");

  return body;
};

export const createUserFile = async (data: CreateUserFileRequestType) => {
  const { body, status } = await tsRestClient.chat.createUserFile({
    body: data,
  });

  if (status !== 200) throw new Error("Failed to create user file");

  return body;
};
